import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search as SearchIcon, ScanBarcode } from "lucide-react";
import { toast } from "sonner";
import { AppShell } from "@/components/AppShell";
import { ListCard } from "@/components/cards";
import { useI18n } from "@/i18n/I18nContext";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Search() {
  const { t } = useI18n();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/products/search?q=${encodeURIComponent(q)}`).then((r) => setResults(r.data)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const isBarcode = /^\d{6,}$/.test(q.trim());
  const lookup = async () => {
    const code = q.trim();
    try { await api.get(`/products/barcode/${code}`); navigate(`/product/${code}`); }
    catch { toast.error(t("product.notFound")); }
  };

  return (
    <AppShell>
      <h1 className="font-heading text-4xl font-extrabold text-slate-900 mb-4">{t("search.title")}</h1>
      <div className="relative mb-4">
        <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
        <Input data-testid="search-input" value={q} onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && isBarcode && lookup()}
          placeholder={t("search.placeholder")} className="h-14 pl-12 rounded-2xl bg-white border-slate-200 text-base" />
      </div>

      {isBarcode && (
        <Button onClick={lookup} data-testid="search-barcode-button" className="w-full rounded-2xl h-12 mb-4 bg-emerald-600 hover:bg-emerald-700">
          <ScanBarcode className="w-4 h-4 mr-2" /> {t("search.findBarcode")} {q.trim()}
        </Button>
      )}

      {results.length === 0 ? (
        <p className="text-slate-400 text-center py-12">{q ? t("search.nothing") : t("search.startTyping")}</p>
      ) : (
        <div>{results.map((p) => (
          <ListCard key={p.barcode} item={{ ...p, score_total: p.score.total }} />
        ))}</div>
      )}
    </AppShell>
  );
}
